var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getMediaActionIdentity } from '../media/mediaIdentity';
var EMPTY_URL_SELECTION_STATE = {
    scpp: null,
    srch: null,
    fltr: null,
};
var normalizeUrlSelectionState = function (item) {
    var _a, _b, _c;
    return ({
        scpp: (_a = item === null || item === void 0 ? void 0 : item.scpp) !== null && _a !== void 0 ? _a : null,
        srch: (_b = item === null || item === void 0 ? void 0 : item.srch) !== null && _b !== void 0 ? _b : null,
        fltr: (_c = item === null || item === void 0 ? void 0 : item.fltr) !== null && _c !== void 0 ? _c : null,
    });
};
var mediaSelectionReducer = function (state, action) {
    var _a;
    switch (action.type) {
        case 'SELECT_MEDIA':
            return __assign(__assign({}, state), { selection: action.selection, modalActive: true, modalType: (_a = action.modalType) !== null && _a !== void 0 ? _a : 'preview' });
        case 'DESELECT_MEDIA':
            return __assign(__assign({}, state), { selection: null, modalActive: false, modalType: null, selectedIds: [] });
        case 'SET_REMOVING_IDS':
            return __assign(__assign({}, state), { removingIds: action.ids });
        case 'CLEAR_REMOVING_IDS':
            return __assign(__assign({}, state), { removingIds: [] });
        case 'SAVE_URL_SELECTION_STATE':
            return __assign(__assign({}, state), { urlSelectionState: normalizeUrlSelectionState(action.item) });
        case 'CLEAR_URL_SELECTION_STATE':
            return __assign(__assign({}, state), { urlSelectionState: __assign({}, EMPTY_URL_SELECTION_STATE) });
        case 'TOGGLE_MULTI_SELECT': {
            var id_1 = getMediaActionIdentity(action.item);
            var isSelected = state.selectedIds.includes(id_1);
            var selectedIds = isSelected
                ? state.selectedIds.filter(function (selectedId) { return selectedId !== id_1; })
                : __spreadArray(__spreadArray([], state.selectedIds, true), [id_1], false);
            var selectedItems = isSelected
                ? state.selectedItems.filter(function (i) { return getMediaActionIdentity(i) !== id_1; })
                : __spreadArray(__spreadArray([], state.selectedItems, true), [action.item], false);
            return __assign(__assign({}, state), { selectedIds: selectedIds, selectedItems: selectedItems });
        }
        case 'SET_MULTI_SELECT':
            return __assign(__assign({}, state), { selectedIds: action.items.map(function (i) { return getMediaActionIdentity(i); }), selectedItems: action.items });
        case 'CLEAR_MULTI_SELECT':
            return __assign(__assign({}, state), { selectedIds: [], selectedItems: [] });
        default: {
            var exhaustiveCheck = action;
            throw Error("MediaReducer: Unhandled action ".concat(String(exhaustiveCheck)));
        }
    }
};
export default mediaSelectionReducer;
